'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _setImmediate = require('./setImmediate');

var _setImmediate2 = _interopRequireDefault(_setImmediate);

var _reusableLazyPromise = require('./utils/reusableLazyPromise');

var _reusableLazyPromise2 = _interopRequireDefault(_reusableLazyPromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var loopDelayBetween = function loopDelayBetween(fn) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var iterations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var rPromise = new _reusableLazyPromise2.default(function (res) {
    var timerID = void 0;

    var _ref = time === 0 ? [_setImmediate2.default, function (_) {
      return (0, _setImmediate.clearImmediate)(timerID);
    }] : [setTimeout, function (_) {
      return clearTimeout(timerID);
    }],
        _ref2 = _slicedToArray(_ref, 2),
        timeout = _ref2[0],
        stop = _ref2[1];

    rPromise.stop = stop;

    var updateTimerID = function updateTimerID(run, time) {
      return timerID = timeout(run, time);
    };

    var run = function run(_) {
      return iterations-- > 0 ? fn() & updateTimerID(run, time) : res();
    };

    updateTimerID(run, time);
  });

  var rPromiseThen = function rPromiseThen() {
    return rPromise.then.apply(rPromise, arguments) && rPromise;
  };

  rPromise.done = rPromiseThen;
  rPromise.run = rPromiseThen;
  return rPromise;
};

exports.default = loopDelayBetween;